import { PRODUCT_CATEGORIES } from "@/features/shop/types";

export const PUBLIC_CATEGORY_LABELS: Record<(typeof PRODUCT_CATEGORIES)[number], string> = {
  vegetables: "Vegetables",
  fruits: "Fruits",
  grains: "Grains",
  livestock: "Livestock",
};

export function formatPublicCategoryLabel(category: string) {
  return (
    PUBLIC_CATEGORY_LABELS[category as keyof typeof PUBLIC_CATEGORY_LABELS] ??
    category.charAt(0).toUpperCase() + category.slice(1)
  );
}

export function buildGoogleMapsUrl(
  query: string,
  coords?: { latitude?: number | null; longitude?: number | null },
) {
  if (coords?.latitude != null && coords?.longitude != null) {
    return `https://www.google.com/maps/search/?api=1&query=${coords.latitude},${coords.longitude}`;
  }

  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
}

